import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { getSessionInfo } from "../../../Redux/reducer/session";
import { useSelector } from "react-redux";
import { getBillStatusKey } from "../../utils/utilities";

/* DRAFT - DDAY - PENDING - APPROVED_PARTIALLY - APPROVED
   DELETED - VALIDATED - ACCEPTED_PARTIALLY - ACCEPTED
   PROCESSED - PAID - PAID_REJECTED - ACTIVE - REJECTED */

const BillsStatus = ({ statusCode }) => {
  const { t } = useTranslation();
  const loggedUser = useSelector((state) => getSessionInfo(state));
  const billStatusCode = getBillStatusKey(statusCode, loggedUser.userType);

  return (
    <span className="status">
      <span className={`${classes[statusCode] || "cancelled"}`}>
        <span>{t(`general.billStates.${billStatusCode}`)}</span>
      </span>
    </span>
  );
};

BillsStatus.propTypes = {
  statusCode: PropTypes.string.isRequired,
};

export default BillsStatus;

const classes = {
  DRAFT: "draft",
  PENDING: "pending",
  ACCEPTED_PARTIALLY: "partial-accepted",
  ACCEPTED: "accepted",
  APPROVED_PARTIALLY: "partial-aproved",
  APPROVED: "aproved",
  REJECTED: "paid_rejected",
  REJECTED_DELETE: "paid_rejected",
  VALIDATED: "validated",
  PROCESSED: "processed",
  PAID: "paid",
  PAID_REJECTED: "paid_rejected",
  EXPIRED: "expired",
};
